import { useQuery, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import axiosInstance from "../../services/axiosInstance";

const instance = axiosInstance();
export async function getContract(proposal_id, searchType) {
  const response = await instance.get(
    `/contract/get/${searchType}/${proposal_id}`
  );
  return response.data;
}

export function useContract(proposal_id, searchType) {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ["contract", searchType, proposal_id],
    queryFn: async () => {
      return getContract(proposal_id, searchType);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["contractAttachments"]);
    },
    onError: (e) => {
      if (e.response?.data?.detail) toast.error(e.response?.data?.detail);
      else toast.error(e.message);
    },
  });
}
